<template>
  <div>
    <div class="box" v-for="(item, index) in list" :key="index">
      <div class="contentBox">
        <div class="title">
          <div class="methodTitle">
            <h3 class="HThree">{{ getBizTypeText(item.bizType)}}</h3>
            <div class="right">
              <h4 class="yve">余额:</h4>
              <p class="yve">￥{{item.opAfterAmount/100}}</p>
            </div>
          </div>
          <div class="methodTitle">
            <div class="left">
              <h3 class="time">{{ item.createdAt }}</h3>
            </div>
            <div class="right">
              <p v-if="item.opAmount>0" class="xiaofeiAdd" >￥+{{item.opAmount/100}}</p>
              <p v-else class="xiaofei">￥{{item.opAmount/100}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  watch: {},
  computed: {},
  methods: {
    boxBtn (e) {
      this.$router.push({ name: 'PurchaseXQ', params: { orderId: e } })
    },
    getBizTypeText (bizType) {
      const statusMap = {
        1: '账户充值',
        2: '其它收支',
        3: '充值套餐'
      }
      return statusMap[bizType] || '未知'
    }
  },
  beforeCreate () {},
  created () {},
  mounted () {}
}
</script>

<style scoped lang='less'>
  .box {
    width: 600px;
    height: 180px;
    background-color: #fff;
    margin: 0 auto 20px;
    box-shadow: 0 4px 10px 5px rgba(15,27,115,8%);
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 15px;
    .contentBox {
      width: 100%;
      height: 150px;
      .title {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .methodTitle {
          display: flex;
          justify-content: space-between;
          // padding: 20px 0 0 40px;
          .HThree {
            flex: 1;
            font-size: 28px;
            line-height: 20px;
            font-weight: 400;
          }
          .right {
            display: flex;
            font-size: 28px;
            font-weight: 400;
            .xiaofeiAdd {
              color: #13227a;
            }
            .xiaofei {
              color: #ff4427;
            }
          }
          .left {
            display: flex;
            align-items: flex-end;
            font-size: 25px;
            color: #9d9da3!important;
            .time {
              font-weight: 400;
              color: #9da9c3;
              font-size: 30px;
            }
          }
        }
      }
    }
  }
</style>
